import { notSavedInSharing } from '../../helper/functions'
import Firestore from '../initFirebase'
import { globalOnDemandVars } from '../../helper/context'

export let onboardingValues = {
  total: 0,
  organize: 0,
  memorizeStartPage: 0,
  memorize: 0,
  playground: 0,
  dashboard: 0,
  guideBooleans: {
    1: false,
    1.5: false,
    2: false,
    3: false,
    4: false,
    5: false,
    5.5: false,
    6: false,
    7: false,
    8: false,
    9: false,
    10: false
  },
  lastUpdate: 'new'
}
if (process.env.NODE_ENV !== 'production') {
  onboardingValues = {
    total: 10,
    organize: 10,
    memorizeStartPage: 10,
    memorize: 10,
    playground: 10,
    dashboard: 10,
    guideBooleans: {
      1: true,
      1.5: false,
      2: false,
      3: true,
      4: false,
      5: false,
      6: false,
      7: false,
      8: false,
      9: true,
      10: false
    },
    lastUpdate: null
  }
}

onboardingValues = {
  total: 10,
  organize: 10,
  memorizeStartPage: 10,
  memorize: 10,
  playground: 10,
  dashboard: 10,
  guideBooleans: {
    1: true,
    1.5: false,
    2: false,
    3: true,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: true,
    10: false
  },
  lastUpdate: null
}

const keys = Object.keys(onboardingValues)

export async function initOnboarding () {
  globalOnDemandVars.set_onboardingReady(false)

  const Doc = Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('onboarding').doc('onboarding')

  const doc = await Doc.get()

  const onboarding = await doc.data()

  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'onboarding',
      value: {
        onboardingValues,
        onboarding
      }
      // , important: true
    })
  }

  if (!onboarding) {
    await Doc.set(onboardingValues)
  } else {
    await Object.keys(onboarding).forEach((key) => {
      if (keys.some((localKey) => (localKey === key))) {
        onboardingValues[key] = onboarding[key]
      }
    })
  }

  globalOnDemandVars.set_onboardingReady(true)
}

export async function updateOnboarding (key, value) {
  if (globalOnDemandVars.isSharing()) {
    notSavedInSharing()
    return
  }
  if (keys.some((localKey) => (localKey === key))) {
    await Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('onboarding').doc('onboarding').update({ [key]: value })
  } else {
    throw (new Error())
  }
}

export async function updateOnboardingWithLocal (key, value) {
  onboardingValues[key] = value
  await updateOnboarding(key, value)
}

export async function updateOnboardingNumberTo (key, number) {
  if (onboardingValues[key] === (number - 1)) {
    await updateOnboardingWithLocal(key, number)
  }
}
